import type { Point } from 'geojson';

export class PointGuard {
  static hasLongitudeAndLatitude(point?: Point): point is { type: 'Point'; coordinates: [number, number] } {
    return !!point && typeof point.coordinates[0] === 'number' && typeof point.coordinates[1] === 'number';
  }
}
